import { domain } from './_init'

export const initializeAuthModel = domain.createEvent()
